<template>
  <label class="flex items-center gap-3 cursor-pointer">
    <input 
      type="checkbox" 
      :checked="modelValue"
      :disabled="disabled"
      @change="handleChange" 
    />
    <span class="text-sm" v-if="$slots.default">
      <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'DSwitch',
  emits: ['update:modelValue', 'change'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(event) {
      const checked = event.target.checked;
      this.$emit('update:modelValue', checked);
      this.$emit('change', checked);
    }
  }
}
</script>